import {
  Checkbox as MuiCheckbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import styled from "styled-components/macro";

export const CfcAttestAuthorizeCallout = styled.section<{
  $isComplete: boolean;
}>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  padding: 16px 16px 32px 32px;
  background-color: ${({ $isComplete, theme }) =>
    $isComplete ? theme.greenPastel : theme.redPastel};
  border-left: 3px solid
    ${({ $isComplete, theme }) =>
      $isComplete ? theme.resultsNegativeGreen : theme.redMedium};
`;

export const CfcAttestAuthorizeTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  line-height: 28px;
  font-family: bold;
  color: ${({ theme }) => theme.greyDark};
`;

export const CfcAttestAuthorizeLead = styled.p`
  margin: 0;
  padding-top: 16px;
  font-size: 16px;
  line-height: 24px;
  font-family: light;
  color: ${({ theme }) => theme.greyDark};
`;

export const CfcAttestAuthorizeCheckboxGroup = styled.fieldset`
  margin: 0;
  border: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0 0;
`;

export const CfcAttestAuthorizeCheckboxLabel = styled(FormControlLabel)`
  && {
    align-items: flex-start;
    margin: 0;

    .MuiCheckbox-root {
      margin-right: 10px;
      padding: 0;
    }

    .MuiFormControlLabel-label {
      flex: 1;
      min-width: 0;
      padding-top: 0;
      font-size: 16px;
      line-height: 24px;
      font-family: light;
      color: ${({ theme }) => theme.greyDark};
      white-space: pre-wrap;
    }

    .MuiFormControlLabel-label strong {
      font-family: bold;
    }

    .Mui-checked {
      color: ${({ theme }) => theme.redMedium};
    }
  }
`;

export const CfcAttestAuthorizeSignatureLabel = styled(
  CfcAttestAuthorizeCheckboxLabel,
)`
  && {
    align-items: center;
    margin-top: 24px;
  }
`;

export const CfcAttestAuthorizeWarning = styled.strong`
  display: block;
  color: ${({ theme }) => theme.redDark};
`;

export const CfcAttestAuthorizeItalic = styled.em`
  display: block;
`;

export const CfcCollectionDatePanel = styled.div`
  margin-top: 16px;
  padding: 20px 32px 24px;
  background-color: ${({ theme }) => theme.white};
`;

export const CfcCollectionDateField = styled(TextField)`
  && {
    width: min(60%, 440px);
    min-width: 280px;

    .MuiInputLabel-root {
      color: ${({ theme }) => theme.blueDark};
      font-family: light;
    }

    .MuiInputLabel-root.Mui-error,
    .MuiFormHelperText-root.Mui-error {
      color: ${({ theme }) => theme.redDark};
    }

    .MuiFormHelperText-root {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 8px 0 0;
      font-family: light;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const CfcAttestAuthorizeLegalText = styled.p`
  margin: 0;
  padding-top: 32px;
  font-size: 16px;
  line-height: 24px;
  font-family: light;
  color: ${({ theme }) => theme.greyDark};
`;

export const CfcCheckbox = styled(MuiCheckbox)`
  && {
    color: ${({ theme }) => theme.greyLight};
    &.Mui-checked {
      color: ${({ theme }) => theme.redMedium};
    }
  }
`;
